import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const resolveStorage = () => {
  try {
    const testKey = '__tbd_user_store__'
    sessionStorage.setItem(testKey, '1')
    sessionStorage.removeItem(testKey)
    return sessionStorage
  } catch (err) {
    // sessionStorage not available (SSR/blocked); fall back to in-memory store
    return {
      getItem: () => null,
      setItem: () => {},
      removeItem: () => {},
    }
  }
}

const useUserStore = create(
  persist(
    (set, get) => ({
      patient: null,
      isAuth: false,
      setPatient: patient => set({ patient }),
      setIsAuth: isAuth => set({ isAuth }),
    }),
    {
      name: 'tbd-pu',
      getStorage: resolveStorage,
    }
  )
)

export default useUserStore
